import { InfoCircleIcon, UserCircleIcon } from "@octopusdeploy/design-system-icons";
import type { CertificateResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import CertificateDetail from "~/areas/library/components/Certificates/Certificate/CertificateDetail";
import { CertificateExpiryChip } from "~/components/Chips/index";
import { withTheme } from "~/components/Theme/index";
import { ExpandableFormSection, Summary, type SummaryNode } from "~/components/form/index";
import styles from "./style.module.less";
interface ExistingCertificateDetailsFormSectionsProps {
    model: CertificateResource;
}
export function ExistingCertificateDetailsFormSections(props: ExistingCertificateDetailsFormSectionsProps) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const nonNullCertificateChain = props.model.CertificateChain!;
    return (<div>
            <ExpandableFormSection errorKey="Details" title="Details" summary={detailsSummary(props.model)} help="Certificate details.">
                <CertificateDetail certificate={props.model}/>
                {nonNullCertificateChain.length > 0 && (<div>
                        <h4>Certificate Chain</h4>
                        {nonNullCertificateChain.map((cert, index) => (<div key={index}>
                                <CertificateDetail certificate={cert}/>
                                <br />
                                <br />
                            </div>))}
                    </div>)}
            </ExpandableFormSection>
        </div>);
}
function detailsSummary(model: CertificateResource): SummaryNode {
    return model
        ? Summary.summary(withTheme((theme) => (<div className={styles.row}>
                      <div className={styles.propertyContainer}>
                          <InfoCircleIcon size={24}/>
                          <span>{model.SubjectCommonName || model.SubjectOrganization || model.SubjectDistinguishedName}</span>
                      </div>
                      <div className={styles.propertyContainer}>
                          <UserCircleIcon size={24}/>
                          <span>{model.SelfSigned ? "Self-Signed" : model.IssuerCommonName || model.IssuerOrganization || model.IssuerDistinguishedName}</span>
                      </div>
                      <div className={styles.propertyContainer}>
                          <CertificateExpiryChip certificate={model}/>
                      </div>
                  </div>)))
        : Summary.placeholder("Certificate details");
}
